module.exports = __webpack_public_path__ + "static/img/nf.99af5a94.svg";